import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  QueryList,
  TemplateRef,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { AnalyticalToolsService } from 'src/app/services/analytical-tools.service';
import { FileUploadService } from 'src/app/services/upload-file.service';
import { ApplicationPermission } from 'src/app/user-management/shared/models/application-permission';
@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.scss'],
})
export class FileUploadComponent implements OnInit {
  @ViewChildren(MatPaginator) paginator2 = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort2 = new QueryList<MatSort>();
  @ViewChild('viewdocument') private viewdocument!: TemplateRef<any>;
  blobStorage:any = Constants.BLOB_STORAGE_URL;
  previewerData = new MatTableDataSource<{
    fileName: string;
    filePath: string;
    fileType: string;
  }>([]);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  previewerColumns: string[] = ['Desc', 'Action','View', 'Remove'];
  filesForm!: FormGroup;
  private dialogRef: MatDialogRef<any> | null = null;
  files: File[] = [];
  filePreviews: { file: File; preview: string }[] = [];
  updatedRecord: { file: File; preview: string }[] = [];
  allFilestoSend: File[] = [];
  fileSave: any;
  headerID: any;
  newHeaderId: any;
  triggerUpdatedData: boolean = true;
  newHeadersid: number;
  viewDocument: any;
  fileType: string;
  doc: string = '';
images: string[] = [];
imageIndexOne = 0;
isCreate = ApplicationPermission.ANALYTICAL_TOOLS_CREATE;
isView: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private spinner: NgxSpinnerService,
    private cdr: ChangeDetectorRef,
    private fileUploadService: FileUploadService,
    private toaster: ToastrService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private sanitizer: DomSanitizer,
    private analyticalToolsService: AnalyticalToolsService
  ) {}
  async ngOnInit() {
    this.filesForm = this.fb.group({ file: [''] });
    this.newHeaderId = this.getHeaderID();
    this.isView = this.data.isView;
    if (this.newHeaderId !== 0) {
        await this.fileUploadService.getAtfiles(this.newHeaderId);
        this.files = this.fileUploadService.getFiles();
        this.updatedRecord = this.fileUploadService.updateRecord();
        this.previewerData = new MatTableDataSource<any>(this.updatedRecord);
        this.previewerData.paginator = this.paginator;
        this.getPaginator2(this.previewerData, 0);
        this.cdr.detectChanges();
    } else {
        if (this.updatedRecord === undefined || this.newHeaderId === 0) {
            this.filePreviews = this.fileUploadService.getFilePreviews();
            this.previewerData.data = this.filePreviews.map(({ file }) => ({
                fileName: file.name,
                filePath: '',
                fileType: file.type,
            }));
        } else {
            this.previewerData = new MatTableDataSource<any>(this.updatedRecord);
            this.previewerData.paginator = this.paginator;
            this.getPaginator2(this.previewerData, 0);
        }
    }
}

  getHeaderID(): number {
    const headerId = localStorage.getItem('headerId');
    return parseInt(headerId) ? parseInt(headerId, 10) : 0;
  }

  getPaginator2(data: MatTableDataSource<any>, index: number): void {
    setTimeout(() => {
      data.paginator = this.paginator;
    }, 500);
  }

  public saveNCRFiles(): void {
    this.fileUploadService.saveNCRFiles(this.headerID);
    this.newHeaderId = this.headerID;
  }

  readFile(event: any): void {
    const maxTotalSizeMB = 50;
    const maxFiles = 5;
    if (!this.files) this.files = [];
    if (!this.filePreviews) this.filePreviews = [];
    let totalSizeMB = this.files.reduce(
      (acc, file) => acc + file.size / (1024 * 1024),
      0
    );
    if (event.target.files && event.target.files.length) {
      const totalFiles = this.files.length + event.target.files.length;
      if (totalFiles > maxFiles) {
        this.toaster.error(
          `You can only select up to ${maxFiles} files in total.`
        );
        return;
      }
      Array.from(event.target.files).forEach((file: File) => {
        const fileSizeMB = file.size / (1024 * 1024);
        totalSizeMB += fileSizeMB;
        if (totalSizeMB > maxTotalSizeMB) {
          this.toaster.error(`Total size exceeds ${maxTotalSizeMB} MB.`);
          return;
        }
        this.files.push(file);
        this.allFilestoSend = this.fileUploadService.allFilestoSend;
        this.allFilestoSend.push(file);
        const reader = new FileReader();
        reader.onload = () => {
          const preview = reader.result as string;
          this.filePreviews.push({ file, preview });
          this.previewerData.data = [
            ...this.previewerData.data,
            { fileName: file.name, filePath: preview, fileType: file.type },
          ];
          this.cdr.detectChanges();
        };
        reader.readAsDataURL(file);
      });
      this.fileUploadService.setFiles(this.files);
      this.fileUploadService.setFilePreviews(this.filePreviews);
    }
    this.newHeadersid = this.getHeaderID();
    console.log(this.newHeadersid, 'this.newHeadersid');
    console.log(this.newHeaderId, 'this.newHeaderId');
    this.newHeaderId = this.fileUploadService.addSingleFile();
    if (
      (this.headerID !== 0 && this.headerID != undefined) ||
      (this.newHeadersid !== 0 && this.newHeadersid != undefined)
    ) {
      this.fileUploadService.setFiles(this.files);
      this.fileUploadService.setFilePreviews(this.filePreviews);
      this.fileUploadService.saveNCRFiles(this.newHeaderId).then(() => {
        this.fileUploadService.getAtfiles(this.newHeaderId).then(() => {
            this.updatedRecord = this.fileUploadService.updateRecord();
            this.previewerData = new MatTableDataSource<any>(this.updatedRecord);
            this.previewerData.paginator = this.paginator;
            this.getPaginator2(this.previewerData, 0);
            this.cdr.detectChanges(); 
        });
    });
    
    }
  }

  getFileTypeName(val: string): string {
    const arr = val.split('.');
    return arr && arr.length > 1 ? `( ${arr[arr.length - 1]} )` : ``;
  }

  removeFile(ele: any): void {
    const key = {
      headerFileId: ele.Id,
    };
    this.spinner.show();
    this.analyticalToolsService
      .deleteAtfiles(key)
      .pipe(
        finalize(() => {
          this.spinner.hide();
        })
      )
      .subscribe(
        async (response: any) => {
          this.toaster.success('File Deleted Successfuly');
          await this.fileUploadService.getAtfiles(this.newHeaderId);
          this.updatedRecord = this.fileUploadService.updateRecord();
          this.previewerData = new MatTableDataSource<any>(this.updatedRecord);
          this.previewerData.paginator = this.paginator;
          this.getPaginator2(this.previewerData, 0);
          this.spinner.hide();
          this.fileSave = null;
        },
        (error: any) => {
          this.toaster.error('Error', error.error.message);
          this.spinner.hide();
        }
      );
  }
  isBase64(str: string): boolean {
    try {
      return btoa(atob(str)) === str;
    } catch (err) {
      return false;
    }
  }
  
  decodeBase64(base64: string): string {
    return `data:;base64,${base64}`;
  }
  isBinary(data: any): boolean {
    return data instanceof ArrayBuffer || data instanceof Blob;
  }

  convertBinaryToUrl(binaryData: ArrayBuffer | Blob): SafeUrl {
    const blob = binaryData instanceof ArrayBuffer ? new Blob([binaryData]) : binaryData;
    const objectUrl = URL.createObjectURL(blob);
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl);
  }
  
  ViewFile(path: string) {
    this.newHeaderId = this.getHeaderID();
    if (this.newHeaderId !== 0 && this.newHeaderId !== undefined) {
      
      if (this.isBase64(path)) {
        path = this.decodeBase64(path);
      }
      
  
      this.fileType = this.getFileType(path);
  
      if (this.fileType === 'doc') {
        this.doc = path; 
      } else if (this.fileType === 'image') {
        this.images = [path];
      } else {
        this.viewDocument = this.sanitizer.bypassSecurityTrustUrl(path);
      }
  
      this.dialogRef = this.dialog.open(this.viewdocument, { height: 'auto', width: '100vh' });
    } else {
      this.toaster.warning('Files Are Not Saved Yet');
    }
  }
  
  getFileType(path: string): string {
    const extension = path.split('.').pop()?.toLowerCase();
    if (!extension) return 'unknown';
    if (['jpg', 'jpeg', 'png', 'gif'].includes(extension)) return 'image';
    if (['doc', 'docx', 'pdf', 'ppt', 'pptx', 'xls', 'xlsx', 'txt'].includes(extension)) return 'doc';
    if (['mp4', 'webm', 'ogg'].includes(extension)) return 'video';
    return 'unknown';
  }
  
  closeDialog() {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }
  
  
}
